import React from "react";
import TableHeader from "../tableheader";
import TableRow from "../tablerow";

class Schedule extends React.Component {

  render() {
    return (
      <table className="table">
        <thead>
          <TableHeader
            day="Day"
            event="Event"
            notes="Notes"
            time="Time"
            where="Location"
          />
        </thead>
        <tbody>

          {/* Thursday */}
          <TableRow
            color="purple"
            day="Thursday"
            event="Arrival & Check-in"
            notes="Paperwork and Orientation"
            time="2:00 pm - 7:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="purple"
            event="Supper &amp; Fellowship"
            notes="Tacos/Nachos"
            time="4:00 pm - 6:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="purple"
            event="[Message]: &quot;Inspired, Preserved, It's Here&quot;"
            notes="Speaker: Billy Elmquist"
            time="6:30 pm - 7:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="purple"
            event="Fellowship & Music"
            time="8:00 pm - 10:30 pm"
          />

          {/* Friday */}
          <TableRow
            color="blue"
            day="Friday"
            event="Dining Room Discussions"
            notes="Coffee, Muffins, and Q&amp;A"
            time="6:30 am - 7:30 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Breakfast"
            notes="Sausage gravy & biscuits, baked oatmeal"
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;How Do We Study God&apos;s Word&quot;?"
            notes="Speaker: Caleb Bill"
            time="9:30 am - 10:30 am"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Break"
            notes="Stretch legs"
            time="10:30 am - 10:45 am"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="[Message]: &quot;What We Have In Christ&quot;"
            notes="Speaker: Josh Strelecki"
            time="10:45 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Lunch"
            notes="Soups"
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="Free Time"
            time="2:00 pm - 4:30 pm"
          />

          <TableRow
            color="blue"
            event="[Message]: Women&apos;s Meeting"
            notes="Speaker: Michelle Strelecki"
            time="3:30 pm - 4:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Supper"
            notes="Scalloped potatoes, ham, green bean casserole"
            time="5:30 pm - 6:30 pm"
            where="Dining Hall"
          />

          <TableRow
            color="blue"
            event="[Message]: &apos;The Battle of the Universe&apos;"
            notes="Speaker: Larry Gabbard"
            time="7:00 pm - 8:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="[Message]: &apos;Shall We Continue In Sin?&apos;"
            notes="Speaker: Paul Lucas"
            time="8:15 pm - 9:15 pm"
            where="The Chapel"
          />

          <TableRow
            color="blue"
            event="Fellowship & Music"
            time="9:30 pm - 10:30 pm"
            where="The Chapel"
          />

          {/* Saturday */}
          <TableRow
            color="green"
            day="Saturday"
            event="Dining Room Discussions"
            notes="Coffee, Muffins,  and Q&A"
            time="6:30 am - 8:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="Breakfast"
            notes="Pancakes, sausage, grits"
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="[Message]: &apos;Timothy Sessions&apos;"
            notes="Speakers: Young Men"
            time="9:30 am - 11:15 am"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="[Message]: &apos;Division or Subtraction?&apos;"
            notes="Speakers: Billy Elmquist"
            time="11:15 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Lunch"
            notes="Soups"
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="Camp Photo"
            notes="Report to Kadee Luethge"
            time="2:15 pm"
            where="Chapel Yard"
          />

          <TableRow
            color="green"
            event="[Message]: Men&apos;s Meeting"
            notes="Speaker: Barney Monroe"
            time="2:30 pm - 3:30 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Relay Race"
            notes="Report to Scott Gross"
            time="4:00 pm - 5:30 pm"
            where="Chapel Yard"
          />

          <TableRow
            color="green"
            event="Supper"
            notes="Shepherd&apos;s Pie, Orzo pasta salad"
            time="5:30 pm - 6:30 pm"
            where="Dining Hall"
          />

          <TableRow
            color="green"
            event="[Message]: &quot;No Condemnation?&quot;"
            notes="Speaker: Paul Lucas"
            time="7:00 pm - 8:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="[Q&amp;A]: Panel Questions and Answers"
            notes="Speakers"
            time="8:00 pm - 9:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="green"
            event="Fellowship & Music"
            time="9:00 pm - 11:00 pm"
            where="The Chapel"
          />

          {/* Sunday */}
          <TableRow
            color="red"
            day="Sunday"
            event="Breakfast"
            notes="Egg bake"
            time="8:00 am - 9:00 am"
            where="Dining Hall"
          />

          <TableRow
            color="red"
            event="[Message]: &apos;Babes, Children, Sons&apos;"
            notes="Speaker: Rod Jones"
            time="9:30 am - 10:45 am"
            where="The Chapel"
          />

          <TableRow
            color="red"
            event="[Message]: &apos;Saved For What?&apos;"
            notes="Speaker: Barney Monroe"
            time="11:00 am - 12:00 pm"
            where="The Chapel"
          />

          <TableRow
            color="red"
            event="Lunch"
            notes="Must-go meal"
            time="12:30 pm - 2:00 pm"
            where="Dining Hall"
          />

          <TableRow
            color="red"
            event="Clean Up"
            notes="Cabins, The Chapel, and Dining Hall"
            time="2:00 pm - 3:30 pm"
            where="All Buildings"
          />

        </tbody>
      </table>
    );
  }

}

export default Schedule;
